export enum accountTypes {
    LISTER = 'Lister',
    AGENT = 'Agent'
}